// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    background-color: whitesmoke;
    
}
.search-button {
    background-color: #286090;
    color: white;
    height: 35px;
    padding: 3px 15px;
    border-radius: 5px;
    cursor: pointer;
  }

.scroll{
    color:red;
    font-size: 18px;
    font-weight: 30px;
}
.doa-container {
    border: 1px solid #0b2d71;
    width: 100%;
    margin: 20px auto;
    border-radius: 10px;
    background-color: #fff;
}
.header{
    background-color: #286090;
    text-align: left;
    margin-left:20px;
    margin-right: 20px;
    height:35px;
    
}
.header1{
    padding-top: 5px;
    padding-left: 10px;
    color:black;
}
.catTitle{
    color: #286090;
    margin-left:30px;
    
}
.boldtext{
    font-weight: bold;
    padding-left:70px;
    color:black;
    margin-top:15px;
    padding-bottom: 15px;
}
 
.doa-select-text {
    color: white;
    padding: 10px;
    background-color: #0b2d71;
    text-align: left;
    border-radius: 5px 5px 5px 5px;
    max-width:100%;
}

.doa-container1 {
    border: 2px solid #0b2d71;
    width: 100%;
    border-radius: 10px;
    background-color: #fff;
}

.one{
    font-size: 20px;
    
}

.doatypename{
    float:left;
    margin-left:50px;
}

.employeedetails{
    float:right;
    margin-right:200px;
} 

.container2{
    background-color: #F1F1F1;
    border:solid 1px #d4d4d4;
    border-radius:5px;
    margin-bottom:15px;
    padding:50px;
}
.scroll{
    color:red;
    font-size: 18px;
    font-weight: 30px;
}
.doa-container {
    border: 1px solid #0B2D71;
    width: 100%;
    margin: 20px auto;
    border-radius: 10px;
    background-color: #fff;
}
.header{
    background-color:#5385b0 ;
    text-align: left;
    margin-left:20px;
    margin-right: 20px;
    height:35px;
    
}
.header1{
    padding-top: 5px;
    padding-left: 10px;
    color:black;
}
.catTitle{
    color: rgba(0, 48, 153, 1);
    margin-left:30px;
    font-family:"GothamNarrowBook",Arial,sans-serif ;
}
.boldtext{
    font-weight: bold;
    padding-left:70px;
    color:black;
    margin-top:15px;
    padding-bottom: 15px;
}
 
.doa-select-text {
    color: white;
    padding: 10px;
    background-color: #0b2d71;
    text-align: left;
    border-radius: 5px 5px 5px 5px;
    max-width:100%;
}
.doatype {
    color: black;
    padding-left: 20%;
      
}
.doatype2 {    
    color: black;
    padding-left:55%;    
} 
.one{
    font-size: 20px;
    
}
.container1{
    height:30px;
    width:100%;
    background-color:#5385b0 ;
}

.doatypename{
margin-left:50px;
font-family:"GothamNarrowBook",Arial,sans-serif ;
}

.employeedetails{
    float:right;
    margin-right:200px;
}

.radio-label {
    margin-right: 15px;
    margin-left:5px;
  }
  .emailinput{
    margin-left:117px;
    height: 35px;
    border-radius:5px;
    width:230px;
  }
  .dateinput{
    margin-left:100px;
    height: 35px;
    border-radius:5px;
    width:150px;
  }
   .menu{
    background-color:#5385b0; 
  }
  .option{
    background-color: white;
    color: #000;
    font-weight: bolder;
  } 

  .viewAction{
    float: left;
    margin-right:300px;
  }
    /* Modal styles */
.modal {
    display: none;
    position: fixed;
    z-index: 1;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: transparent;
  }
  
  .modal-content {
    background-color: #fefefe;
    margin: auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    max-width: 500px;
    height: auto;
    max-height: 300px;
    overflow-y: auto;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  }
  
  
  /* OK button styles */
  #closeSuccessModal {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px 10px;
    text-align: right;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 10px 0;
    cursor: pointer;
    border-radius: 4px;
    position: absolute;
    right: 20px;
    bottom: 20px;
  }
  
  #closeSuccessModal:hover {
    background-color: #0056b3;
  }
  mat-spinner {
    margin: auto;
    position: absolute; 
    top: 50%; 
    left: 50%; 
    transform: translate(-50%, -50%); 
  }
  
.title{
    font-family: "GothamBold",Arial,sans-serif;
}

.content{
    font-family:"GothamNarrowBook",Arial,sans-serif ;
}
:host {
    font-family: "GothamBold", "Helvetica Neue", Helvetica,Arial, sans-serif;
  }
  .actions {
    display: flex;
    justify-content: center;
  }
  
  .actions button {
    margin-right: 50px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
.form-control-sm.menu:disabled {
    color: #000; 
  }
   
  select:disabled {
    color: #000; 
    border-color: rgba(118, 118, 118, 0.3);
  }

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/doa/permanent-doa/permanentdoa.component.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;;AAEhC;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;EACjB;;AAEF;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;;AAEf;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,cAAc;IACd,gBAAgB;;AAEpB;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;;AAEf;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;AACA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gDAAgD;AACpD;AACA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;AAClB;AACA;IACI,YAAY;IACZ,iBAAiB;;AAErB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,eAAe;;AAEnB;AACA;IACI,WAAW;IACX,UAAU;IACV,yBAAyB;AAC7B;;AAEA;AACA,gBAAgB;AAChB,gDAAgD;AAChD;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,WAAW;EACb;GACC;IACC,wBAAwB;EAC1B;EACA;IACE,uBAAuB;IACvB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;IACE,iBAAiB;AACrB;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,cAAc;IACd,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,4EAA4E;EAC9E;;;EAGA,qBAAqB;EACrB;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;EAClC;;AAEF;IACI,0CAA0C;AAC9C;;AAEA;IACI,gDAAgD;AACpD;AACA;IACI,wEAAwE;EAC1E;EACA;IACE,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;AACF;IACI,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sCAAsC;EACxC;;AAEF,g2TAAg2T","sourcesContent":["body {\n    background-color: whitesmoke;\n    \n}\n.search-button {\n    background-color: #286090;\n    color: white;\n    height: 35px;\n    padding: 3px 15px;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n.scroll{\n    color:red;\n    font-size: 18px;\n    font-weight: 30px;\n}\n.doa-container {\n    border: 1px solid #0b2d71;\n    width: 100%;\n    margin: 20px auto;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.header{\n    background-color: #286090;\n    text-align: left;\n    margin-left:20px;\n    margin-right: 20px;\n    height:35px;\n    \n}\n.header1{\n    padding-top: 5px;\n    padding-left: 10px;\n    color:black;\n}\n.catTitle{\n    color: #286090;\n    margin-left:30px;\n    \n}\n.boldtext{\n    font-weight: bold;\n    padding-left:70px;\n    color:black;\n    margin-top:15px;\n    padding-bottom: 15px;\n}\n \n.doa-select-text {\n    color: white;\n    padding: 10px;\n    background-color: #0b2d71;\n    text-align: left;\n    border-radius: 5px 5px 5px 5px;\n    max-width:100%;\n}\n\n.doa-container1 {\n    border: 2px solid #0b2d71;\n    width: 100%;\n    border-radius: 10px;\n    background-color: #fff;\n}\n\n.one{\n    font-size: 20px;\n    \n}\n\n.doatypename{\n    float:left;\n    margin-left:50px;\n}\n\n.employeedetails{\n    float:right;\n    margin-right:200px;\n} \n\n.container2{\n    background-color: #F1F1F1;\n    border:solid 1px #d4d4d4;\n    border-radius:5px;\n    margin-bottom:15px;\n    padding:50px;\n}\n.scroll{\n    color:red;\n    font-size: 18px;\n    font-weight: 30px;\n}\n.doa-container {\n    border: 1px solid #0B2D71;\n    width: 100%;\n    margin: 20px auto;\n    border-radius: 10px;\n    background-color: #fff;\n}\n.header{\n    background-color:#5385b0 ;\n    text-align: left;\n    margin-left:20px;\n    margin-right: 20px;\n    height:35px;\n    \n}\n.header1{\n    padding-top: 5px;\n    padding-left: 10px;\n    color:black;\n}\n.catTitle{\n    color: rgba(0, 48, 153, 1);\n    margin-left:30px;\n    font-family:\"GothamNarrowBook\",Arial,sans-serif ;\n}\n.boldtext{\n    font-weight: bold;\n    padding-left:70px;\n    color:black;\n    margin-top:15px;\n    padding-bottom: 15px;\n}\n \n.doa-select-text {\n    color: white;\n    padding: 10px;\n    background-color: #0b2d71;\n    text-align: left;\n    border-radius: 5px 5px 5px 5px;\n    max-width:100%;\n}\n.doatype {\n    color: black;\n    padding-left: 20%;\n      \n}\n.doatype2 {    \n    color: black;\n    padding-left:55%;    \n} \n.one{\n    font-size: 20px;\n    \n}\n.container1{\n    height:30px;\n    width:100%;\n    background-color:#5385b0 ;\n}\n\n.doatypename{\nmargin-left:50px;\nfont-family:\"GothamNarrowBook\",Arial,sans-serif ;\n}\n\n.employeedetails{\n    float:right;\n    margin-right:200px;\n}\n\n.radio-label {\n    margin-right: 15px;\n    margin-left:5px;\n  }\n  .emailinput{\n    margin-left:117px;\n    height: 35px;\n    border-radius:5px;\n    width:230px;\n  }\n  .dateinput{\n    margin-left:100px;\n    height: 35px;\n    border-radius:5px;\n    width:150px;\n  }\n   .menu{\n    background-color:#5385b0; \n  }\n  .option{\n    background-color: white;\n    color: #000;\n    font-weight: bolder;\n  } \n\n  .viewAction{\n    float: left;\n    margin-right:300px;\n  }\n    /* Modal styles */\n.modal {\n    display: none;\n    position: fixed;\n    z-index: 1;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    background-color: transparent;\n  }\n  \n  .modal-content {\n    background-color: #fefefe;\n    margin: auto;\n    padding: 20px;\n    border: 1px solid #888;\n    width: 80%;\n    max-width: 500px;\n    height: auto;\n    max-height: 300px;\n    overflow-y: auto;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  }\n  \n  \n  /* OK button styles */\n  #closeSuccessModal {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px 10px;\n    text-align: right;\n    text-decoration: none;\n    display: inline-block;\n    font-size: 14px;\n    margin: 10px 0;\n    cursor: pointer;\n    border-radius: 4px;\n    position: absolute;\n    right: 20px;\n    bottom: 20px;\n  }\n  \n  #closeSuccessModal:hover {\n    background-color: #0056b3;\n  }\n  mat-spinner {\n    margin: auto;\n    position: absolute; \n    top: 50%; \n    left: 50%; \n    transform: translate(-50%, -50%); \n  }\n  \n.title{\n    font-family: \"GothamBold\",Arial,sans-serif;\n}\n\n.content{\n    font-family:\"GothamNarrowBook\",Arial,sans-serif ;\n}\n:host {\n    font-family: \"GothamBold\", \"Helvetica Neue\", Helvetica,Arial, sans-serif;\n  }\n  .actions {\n    display: flex;\n    justify-content: center;\n  }\n  \n  .actions button {\n    margin-right: 50px;\n    margin-top: 30px;\n    margin-bottom: 30px;\n  }\n.form-control-sm.menu:disabled {\n    color: #000; \n  }\n   \n  select:disabled {\n    color: #000; \n    border-color: rgba(118, 118, 118, 0.3);\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
